import { get } from '@/helpers/httpHandler';

export default {
  getIcons({ commit }, { params } = {}) {
    return get(`/icons/materialdesignicons`, params).then(response => {
      commit('setIcons', response.data.data);

      return response;
    });
  }
};
